import { render, staticRenderFns } from "./farmercompany_details.vue?vue&type=template&id=3fff9972"
import script from "./farmercompany_details.vue?vue&type=script&lang=js"
export * from "./farmercompany_details.vue?vue&type=script&lang=js"
import style0 from "./farmercompany_details.vue?vue&type=style&index=0&id=3fff9972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports